module.exports = __webpack_public_path__ + "media/images/front/varieties/NAVELINA-729880f1f45e4b62a11c7506e7f358a5.jpg";